export default __webpack_public_path__ + "static/media/logo_white.e3d04443.svg";